/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface ResourceAccess
 */
export interface ResourceAccess {
  /**
   *
   * @type {Set<string>}
   * @memberof ResourceAccess
   */
  roles: Set<string>;
}

/**
 * Check if a given object implements the ResourceAccess interface.
 */
export function instanceOfResourceAccess(value: object): value is ResourceAccess {
  if (!('roles' in value) || value['roles'] === undefined) return false;
  return true;
}

export function ResourceAccessFromJSON(json: any): ResourceAccess {
  return ResourceAccessFromJSONTyped(json, false);
}

export function ResourceAccessFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResourceAccess {
  if (json == null) {
    return json;
  }
  return {
    roles: json['roles']
  };
}

export function ResourceAccessToJSON(value?: ResourceAccess | null): any {
  if (value == null) {
    return value;
  }
  return {
    roles: Array.from(value['roles'] as Set<any>)
  };
}
